import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const RankingsService = {
  async getAll() {
    return safeRequest(
      apiClient.get("/rankings").then((response) => response.data),
    );
  },
  async create(payload) {
    return safeRequest(
      apiClient.post("/rankings", payload).then((response) => response.data),
    );
  },
  async update(rankingId, payload) {
    return safeRequest(
      apiClient.patch(`/rankings/${rankingId}`, payload).then((response) => response.data),
    );
  },
  async getRounds(rankingId) {
    return safeRequest(
      apiClient.get(`/rankings/${rankingId}/rounds`).then((response) => response.data),
    );
  },
  async createRound(rankingId, body = {}) {
    return safeRequest(
      apiClient.post(`/rankings/${rankingId}/rounds`, body).then((response) => response.data),
    );
  },
  async addPlayers(rankingId, playerIds) {
    return safeRequest(
      apiClient
        .post(`/rankings/${rankingId}/players`, { playerIds })
        .then((response) => response.data),
    );
  },
  async getStandings(rankingId, categoryId) {
    return safeRequest(
      apiClient
        .get(`/rankings/${rankingId}/standings`, { params: { categoryId } })
        .then((response) => response.data),
    );
  },
  async removePlayer(rankingId, playerId) {
    return safeRequest(
      apiClient
        .delete(`/rankings/${rankingId}/players/${playerId}`)
        .then((response) => response.data),
    );
  },
};
